import { CognitoRefreshToken, CognitoUser, CognitoUserSession } from "amazon-cognito-identity-js";
import { parseTokens } from "utils/TokenUtils/parseTokens";

export async function refreshToken(currentUser: CognitoUser, refreshToken: string): Promise<any> {
	return new Promise((resolve, reject) => {
		if (currentUser && refreshToken) {
			currentUser?.refreshSession(new CognitoRefreshToken({ RefreshToken: refreshToken }), (error, newSession: CognitoUserSession) => {
				if (error) {
					reject(error);
				} else {
					resolve(parseTokens(newSession));
				}
			});
		} else {
			reject("Missing user or refresh token");
		}
	});
}
